export const DIALECT_WALLET_CONFIG_STORAGE_KEY = 'dialect-wallet-config';
